import React, { FC } from "react";
import {
  CheckoutSession,
  Order,
  OrderItem,
  PaymentIntent,
  Sku,
} from "@prisma/client";
import { classNames } from "@utils/classNames";
import { moneyFormatter } from "@utils/formatters/moneyFormatter";
import { DateTimePreciseValue } from "@components/Values/DateTimePreciseValue";

interface Props {
  orderItems: (OrderItem & {
    order: Order & {
      checkoutSession: CheckoutSession;
      paymentIntent: PaymentIntent;
    };
    sku: Sku;
  })[];
}

export const JobPostPurchaseHistory: FC<Props> = ({ orderItems }) => {
  // Sort by multiple fields (io.order.createdAt, io.sku.order) using chained sort.
  const sortedOrderItems = orderItems.sort(
    (a, b) =>
      a.order.createdAt.getTime() - b.order.createdAt.getTime() ||
      a.sku.sortOrder - b.sku.sortOrder
  );

  return (
    <div className="border rounded-md">
      <div className="p-4 pt-3 pb-2">
        <h3 className="text-xs uppercase leading-6 font-bold ">
          Purchase History
        </h3>
      </div>

      <div className="">
        {orderItems.map((oi, idx) => {
          return (
            <div
              key={oi.id}
              className={classNames(
                "sm:flex sm:justify-between mx-4 pt-2 pb-3 text-xs border-green-900/10",
                idx > 0 ? "border-t" : ""
              )}
            >
              <div className="">
                <div>
                  <div className="mt-1 mb-1 font-bold">{oi.sku.name}</div>
                  <div className="">{oi.sku.description}</div>
                </div>
                <div className="mt-1 font-medium">
                  {moneyFormatter.format(oi.sku.priceAmount / 100)}
                </div>
                <div className="mt-1 mb-1">
                  <DateTimePreciseValue date={oi.createdAt} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
